/* eslint-disable react/default-props-match-prop-types */
import React from 'react'
import { Cell } from 'rsuite-table'
import EditIcon from '@rsuite/icons/Edit'
import TrashIcon from '@rsuite/icons/Trash'
import VisibleIcon from '@rsuite/icons/Visible'
import ShareOutlineIcon from '@rsuite/icons/ShareOutline'
import PlusIcon from '@rsuite/icons/Plus'
import { RiSecurePaymentFill, RiInformationLine } from 'react-icons/ri'
import { Whisper, Tooltip } from 'rsuite'
import { notifyError } from 'utils'
import { MdLocalFlorist, MdFileDownload, MdRefresh } from 'react-icons/md'
import './ActionCell.scss'

type Props = {
  rowData?: any,
  dataKey: string,
  onAction?: (eventKey: string | undefined, rowData: any) => void,
  actionOptions?: string[],
  tooltip?: boolean,
  disableViewWhenNoImage?: boolean,
  style?: React.CSSProperties,
  disableEdit?: boolean
}
const defaultProps = {
  rowData: undefined,
  actionOptions: [],
  onAction: () => { },
  disableEdit: false
}

const defaultOptions = [
  { label: 'View', eventKey: '1', icon: <VisibleIcon /> },
  { label: 'Edit', eventKey: '2', icon: <EditIcon /> },
  { label: 'Delete', eventKey: '3', icon: <TrashIcon /> },
  { label: 'Share', eventKey: '4', icon: <ShareOutlineIcon /> },
  { label: 'View Farms', eventKey: '6', icon: <MdLocalFlorist /> },
  { label: 'Download Pdf', eventKey: '7', icon: <MdFileDownload /> },
  { label: 'Task Log', eventKey: '5', icon: <RiInformationLine /> },
  { label: 'Make Payment', eventKey: '8', icon: <RiSecurePaymentFill /> },
  { label: 'Redo', eventKey: '9', icon: <MdRefresh size={15} /> },
  { label: 'Rule Configration', eventKey: '10', icon: <PlusIcon /> }
]

const ActionCell: React.FC<Props> = ({
  rowData,
  dataKey,
  actionOptions = [],
  tooltip,
  disableViewWhenNoImage = false,
  disableEdit = false,
  ...props
}) => {
  const hasImage = Boolean(rowData?.screenshot)
  const optionsToDisplay =
    actionOptions.length > 0
      ? defaultOptions.filter((option) => actionOptions.includes(option.label))
      : defaultOptions

  const handleActionClick = (eventKey: string | undefined) => {
    if (!eventKey || typeof props.onAction !== 'function') return
    if (
      eventKey === '9' &&
      (rowData?.status === 'PENDING' ||
        rowData?.status === 'COMPLETED' ||
        rowData?.status === 'FAILED' ||
        rowData?.status === 'RAW_RESPONSE_SAVED' ||
        rowData?.status === 'IN_PROGRESS') &&
      disableEdit
    ) {
      return
    }

    if (disableViewWhenNoImage && eventKey === '1' && !hasImage) {
      notifyError('No image available')
      return
    }

    props.onAction(eventKey, rowData)
  }

  return (
    <Cell {...props} className="link-group" onClick={(e) => e.stopPropagation()}>
      <div className="action-icons-wrapper">
        {optionsToDisplay.map((option) => {
          const isDisabled =
            option.eventKey === '9' &&
            (rowData?.status === 'PENDING' ||
              rowData?.status === 'COMPLETED' ||
              rowData?.status === 'FAILED' ||
              rowData?.status === 'RAW_RESPONSE_SAVED' ||
              rowData?.status === 'IN_PROGRESS') &&
            disableEdit

          return (
            <div
              key={option.eventKey}
              className={`action-icon ${isDisabled ? 'disabled' : ''}`}
              role="button"
              tabIndex={0}
              onClick={() => !isDisabled && handleActionClick(option.eventKey)}
              onKeyDown={(e) => {
                if (!isDisabled && (e.key === 'Enter' || e.key === ' ')) {
                  handleActionClick(option.eventKey)
                }
              }}
            >
              {tooltip ? (
                <Whisper
                  key={option.eventKey}
                  placement="bottom"
                  trigger="hover"
                  speaker={
                    <Tooltip>
                      {isDisabled
                        ? 'only untrained document retrained'
                        : option.label}
                    </Tooltip>
                  }
                >
                  <div className="icon-container">{option.icon}</div>
                </Whisper>
              ) : (
                <div className="icon-container">{option.icon}</div>
              )}
            </div>
          )
        })}
      </div>
    </Cell>
  )
}
ActionCell.defaultProps = defaultProps
export default ActionCell
